// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Form } from './form';
import { redirect } from '../form-redirect';

/**
 * @class Jsw.form.GetPassword
 * @extends Jsw.form.Form
 */
export const GetPassword = Class.create(Form, {
    _initComponentElement($super) {
        $super();

        const content = '' +
            '<div class="login-info">' +
                `<h3>${this.lmsg('label')}</h3>${this.lmsg('text')}` +
            '</div>' +

            '<div id="getLinkSection-username-form-row" class="form-row">' +
                `<div class="field-name"><label for="getLinkSection-username">${this.lmsg('loginLabel')}&nbsp;</label></div>` +
                '<div class="field-value">' +
                    `<input type="text" name="login_name" id="getLinkSection-username" value="${this._getConfigParam('loginNameValue', '')}" class="input-text" />` +
                '</div>' +
            '</div>' +

            '<div id="getLinkSection-email-form-row" class="form-row">' +
                `<div class="field-name"><label for="getLinkSection-email">${this.lmsg('emailLabel')}&nbsp;</label></div>` +
                '<div class="field-value">' +
                    `<input type="text" name="email" id="getLinkSection-email" value="${this._getConfigParam('emailValue', '')}" class="input-text" />` +
                '</div>' +
            '</div>';

        this._componentElement.update(
            '<div id="getLinkSection" class="form-box">' +
                `<div id="getLinkSection-content-area">${this._getConfigParam('warnings', '')}${content}</div>` +
            '</div>' +

            '<div class="btns-box">' +
                '<div class="box-area">' +
                    '<div class="form-row">' +
                        '<div class="field-name">' +
                        '</div>' +
                        '<div class="field-value">' +
                            '<span id="btn-send" class="btn">' +
                                `<button type="submit" value="" name="send">${this.lmsg('send')}</button>` +
                            '</span>' +
                            '<span id="btn-cancel" class="btn">' +
                                `<button id="getLinkSection-cancel-button" type="button" value="" name="cancel">${this.lmsg('cancel')}</button>` +
                            '</span>' +

                            '<input type="image" src="/smb/images/blank.gif" style="border: 0; height: 0; width: 0; position: absolute;" />' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>'
        );

        this._componentElement.down('#getLinkSection-cancel-button').observe('click', function () {
            redirect('/login_up.php');
        });
        this._componentElement.down('#getLinkSection-username').focus();
    },
});



// WEBPACK FOOTER //
// ./jsw/form/get-password.js